import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { allProductByTagsAPI } from "../../../Apis/ProductApi";
import { CurrencyContext } from "../../../provider/CurrencyProvider";
import { HomeProductsSendInquiry } from "../../../assets/svg/allSvg";

const ProductsCategoryCard = ({ title, description, tags }) => {
  const [allProductsData, setAllProductsData] = useState([]);
  const [visibleCards, setVisibleCards] = useState(3); // Default to 3 cards for medium and larger devices
  const navigate = useNavigate();

  const { calculatedPrice, getCurrencySymbol } = useContext(CurrencyContext);

  const handleViewAllProducts = () => {
    navigate("/AllProductsPage"); // Redirect to inquiries page
  };

  const handleViewProductId = (productId) => {
    navigate(`/productId/${productId}`); // Redirect to productID page
  };

  const getProductsData = async () => {
    try {
      const response = await allProductByTagsAPI(tags);
      if (response?.products?.length > 0) {
        setAllProductsData(response.products.slice(0, visibleCards));
      } else if (response && response.message === "No data found") {
        setAllProductsData([]);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // console.log(window.innerWidth)

  useEffect(() => {
    const updateVisibleCards = () => {
      if (window.innerWidth < 768) {
        setVisibleCards(2); // Up to 2 cards for small devices
      } else {
        setVisibleCards(3); // Up to 3 cards for medium and larger devices
      }
    };

    updateVisibleCards(); // Initial check
    window.addEventListener("resize", updateVisibleCards); // Update on resize

    return () => window.removeEventListener("resize", updateVisibleCards); // Cleanup on unmount
  }, []);

  useEffect(() => {
    getProductsData();
  }, [tags, visibleCards]);

  return (
    <div className="products-card text-left flex flex-col w-[328px] h-[310px] md:w-[720px] md:h-[430px] lg:w-[1241px] max-w-auto mx-auto lg:h-[430px]">
      <p className="text-[14px] md:text-[18px] lg:text-[20px] font-semibold w-[131px] h-[21px] md:w-[168px] md:h-[30px] lg:w-[187px] lg:h-[30px] text-[#000000] select-none">
        {title}
      </p>
      <hr className="bg-[#FF8100] w-[147px] md:w-[200px] lg:w-[233px] h-[4px] rounded-full mt-[8px] md:mt-0" />
      <p className="hidden md:block products-card-description font-normal leading-[30px] text-[14px] mt-[15px] mb-[17px] w-auto h-[30px] select-none text-black">
        {description}
      </p>

      <div className="products-card-main md:w-full md:bg-white w-[328px] h-[263px] md:h-[329px] lg:w-[600px] lg:h-[340px] rounded-[10px] md:px-[20px] md:py-[16px] md:shadow-[0_0px_0px_1px_rgba(0,0,0,0.07)] mt-[13px] md:mt-0">
        <div className="grid grid-cols-2 md:grid-cols-3 place-items-center gap-x-[20px] md:gap-x-0 w-[328px] h-[263px] md:w-full md:h-[264px] lg:w-[559px] lg:h-[263px]">
          {allProductsData.length > 0 ? (
            allProductsData.map((product, index) => (
              <div
                key={index}
                className="bg-[#F8F8F8] flex flex-col w-[154px] h-[263px] md:w-[170px] md:h-[263px] rounded-[10px] shadow-[0_0px_0px_1px_rgba(0,0,0,0.10)]"
              >
                <button className="w-[154px] h-[110px] md:h-[123px] md:w-[170px] bg-[#F2F2F2] md:bg-[#F8F8F8] rounded-t-[10px] flex items-center justify-center">
                  <img
                    className="w-[136px] h-[90px] md:w-[146px] md:h-[100px] object-cover"
                    src={product.images[0]}
                    alt={`productImg${index}`}
                    onClick={() => handleViewProductId(product.productID)}
                  />
                </button>
                <div className="hidden md:block px-[12px]">
                  <hr className="w-full bg-[#E8E8E8]" />
                </div>
                <div className="w-[154px] h-[153px] md:w-[170px] md:h-[140px] pt-[14px] px-[10px] pb-[10px] md:pt-[16px] md:px-[13px] md:pb-[16px] bg-white md:bg-[#F8F8F8] rounded-b-[10px] flex flex-col">
                  <p className="productName w-full h-[21px] md:h-[17px] text-[14px] md:text-[16px] font-semibold mb-[5px] md:mb-[18px]">
                    {product.productTitle.slice(0, 12)}...
                  </p>
                  <p className="productPrice w-full h-[18px] md:h-[21px] text-[12px] font-semibold md:font-medium md:text-[14px] mb-[8px] md:mb-[9px]">
                    {getCurrencySymbol()} {calculatedPrice(product.maxPrice)}
                  </p>
                  <p className="productDesc w-[135px] h-[36px] md:w-[144px] md:h-[43px] text-[12px] md:text-[14px] mb-[9px] md:mb-0">
                    {product.shortDesc.slice(0, 23)}...
                  </p>
                  <button className="md:hidden w-[134px] h-[32px] bg-[#FF6300] text-white font-medium text-[12px] rounded-[5px] flex items-center justify-center gap-x-[8px]">
                    {HomeProductsSendInquiry}
                    Send Inquiry
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="flex items-center justify-center text-gray-500">
              Coming Soon.....
            </div>
          )}
        </div>
        {allProductsData.length > 0 && (
          <div className="w-full text-center hidden md:block">
            <button
              className="view-all text-[14px] font-semibold leading-[16px] text-[#FF6300] text-center pt-[20px]"
              onClick={handleViewAllProducts}
            >
              View All Products
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductsCategoryCard;
